module.exports = __webpack_public_path__ + "img/icone-filtro.5c07e597.svg";